<template>
  <div class="container">
    <div style="width: 87px; height: auto; overflow: hidden; top:100px; right:20px; position: fixed; z-index:9999">
      <a href="/"><img src="../assets/image/pc1.jpg" style="width: 87px; height: auto; display: block;"></a>
    </div>

    <div style="width: 70px; height: auto; overflow: hidden; top:100px; left:20px; position: fixed; z-index:9999">
      <a href="/"><img src="../assets/image/pc2.jpg" style="width:70px; height: auto; display: block;"></a>
    </div>

    <div class="containerTop">
      <!-- 背景轮播图 -->
      <div class="ziHead">
        <div class="swiper-container" id="bigPhoto">
          <div class="swiper-wrapper">
            <div class="swiper-slide"  v-for="(item, index) in imgList" :key="index">
              <img class="swiper_img" :src="item.fileName" >
            </div>
          </div>
        </div>
      </div>
      <div class="header1">
        <div class="top clearfixe">
          <div class="logo fl">
            <a href="/"><img src="../assets/image/gsqj_1.png"></a>
          </div>
          <div class="sousuo flr">
            <div class="sousuo1"></div>
            <div style="width: 265px; height: 42px;
                background-color: rgb(239, 239, 239);
                border-top: 1px solid rgb(199, 210, 227);
                border-right: 1px solid rgb(199, 210, 227);
                border-bottom: 1px solid rgb(199, 210, 227);
                border-left: none;
                line-height: 42px;
                border-image: initial;
                margin-left: -5px;
                float: left;">
              <el-input v-model="searchValue" placeholder="请输入关键词" style="width: 200px; margin-left: 4px;"></el-input>
              <el-button
                type="submit"
                class="btn "
                @click="handleSearch">搜索
              </el-button>
            </div>
          </div>
        </div>

        <div class="wrap clearfloat">
          <div class="nav_box">
            <ul class="clearfloat">
              <li :class="{'active':active == 0}">
                <div class="nav_grop">
                  <h2><router-link to="/">网站首页</router-link></h2>
                </div>
              </li>
              <li v-for="(item, index) in navList" :key="index" :class="{'active':active == item.id}">
                <div
                  class="nav_grop" 
                  @mouseenter="navShow(item.channelId)"
                  @mouseleave="navClose()">
                  <h2>
                    <a 
                      v-if="item.child.length && item.child[0].url && item.child[0].url !== ''" 
                      target="_blank"
                      :href="item.url">
                      {{item.name}}
                    </a>
                    <a 
                      v-if="item.child.length && (!item.child[0].url || item.child[0].url == '')" 
                      :href="item.catalog == 1 ? `/listPage/${item.child[0].entTChannelUuid}` : item.catalog == 2 ? `/list/${item.child[0].entTChannelUuid}` : `/listPic/${item.child[0].entTChannelUuid}`">
                      {{item.name}}
                    </a>
                    <a 
                      v-if="!item.child.length" 
                      :href="item.catalog == 1 ? `/listPage/${item.entTChannelUuid}` : item.catalog == 2 ? `/list/${item.entTChannelUuid}` : `/listPic/${item.entTChannelUuid}`">
                      {{item.name}}
                    </a>
                  </h2>
                  <el-collapse-transition>
                    <div class="nav_down" v-show="navDown == item.channelId">
                      <div class="nav_down_wrap clearfloat" v-show="item.child.length != 0">
                        <p v-for="(item1, index1) in item.child" :key="index1">
                          <a 
                            v-if="item1.url && item1.url !== ''" 
                            target="_blank" 
                            :href="item1.url">
                            {{item1.name}}
                          </a>
                          <a 
                            v-if="!item1.url || item1.url == ''" 
                            :href="item1.catalog === 1 ? `/listPage/${item1.entTChannelUuid}` : item1.catalog === 2 ? `/list/${item1.entTChannelUuid}` : `/listPic/${item1.entTChannelUuid}`">
                            {{item1.name}}
                          </a>
                        </p>
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="gonggao clearfixe">
          <div class="gonggao_1">
            <div class="home_pre_l fl">
              <img src="../assets/image/gsqj_4.png" alt="">
            </div>
            <div class="inner">
              <el-carousel height="133px" direction="vertical" :interval="3000" indicator-position="none">
                <el-carousel-item v-for="item in newsTop" :key="item.id">
                  <div class="homeTopInner">
                    <h3 class="single-line">
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{item.title}}</a>
                      <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{item.title}}</a>
                    </h3>
                    <p>
                      {{item.artDesc | ellipsis}}
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">[查看详情]</a>
                      <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">[查看详情]</a>
                    </p>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>           
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <router-view></router-view>
    </div>

    <div class="footer">
      <p>版权所有：
        <span>甘肃第七建设集团股份有限公司</span>传真：<span>0931-4632001</span>电话：<span>0931-7843852</span>
      </p>
      <p>
        地址：<span>甘肃省兰州市城关区平凉路333号</span> 
        <span><a href="http://beian.miit.gov.cn" target="_blank">陇ICP备10002730号-1</a></span>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010202001816">
          <img style="display: inline;" src="../assets/image/ba.png">&nbsp;&nbsp;<span>甘公网安备 62010202001816号</span></a>
      </p>
    </div>

    <div class="fundong" id="lb" style="display:block" v-show="isfundong">
      <div class="fundong_weixin">
        <a href="#">
          <div class="imgWei" style="width: 79px; height: 113px; display: block;" @mouseenter="showwx" @mouseleave="showwxno"> </div>
        </a>
        <img class="weixinImg" src="../assets/image/zdjt_20.jpg" v-show="isshowwx">
      </div>
      <div class="fundong_youxiang">
        <a href="mailto:qjjt7843824@163.com">
          <div class="email"></div>
        </a>
      </div>
      <!-- @click="display('lb')" -->
      <a class="cha" href="#" @click="closefundong"> 
        <img src="../assets/image/zdjt_29.png">
      </a>
    </div>
  </div>
</template>
<script>
import { getAdvert, getNavChannel,getTopArtList } from '@/api/common'
import Swiper from 'swiper'
export default {
  name: '',
  data(){
    return {
      isfundong: true,
      isshowwx: false,
      txtImg: '',
      searchValue: '',
      active: 0,
      imgList: [],
      navList: [],
      newsTop: [],
      navDown: 0,
    }
  },
  filters: {
    ellipsis: function(value) {
      if (!value) return "";
      if (value.length > 130) {
        return value.slice(0, 130) + "...";
      }
      return value;
    }
  },
  mounted(){
    this.getPath()
    this.getNavChannel()
    this.bannerImg()
    this.getTopArtList()
  },
  created(){

  },
  watch:{
    '$route':'getPath'
  },
  methods: {
    showwx(){
      this.isshowwx = true
    },
    showwxno(){
      this.isshowwx = false
    },
    closefundong(){
      this.isfundong = false
    },
    // 背景图片
    bannerImg() {
      var _this = this
      let data = {
        applicationUuid: _this.webId,
        advertType: 1
      }
      getAdvert(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.imgList = data
          this.$nextTick(() => {
            new Swiper('#bigPhoto', {
              loop: true,
              effect : 'fade',
              // autoplay: {
              //   delay: 3000,
              //   disableOnInteraction: false
              // },
              autoplay: 3000,
              observer: true,
              observeParents: true,             
              observeSlideChildren: true,
            })
          })
        }
      })
    },
    // 头条
    getTopArtList() {
      var _this = this
      let data = {
        applicationUuid: _this.webId
      }
      getTopArtList(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsTop = data
        }
      })
    },
    // 获取导航
    getNavChannel() {
      var _this = this
      let data = {
        applicationUuid: _this.webId
      }
      getNavChannel(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.navList = data.slice(0, 8)
        }
      })
    },
    handleSearch() {
      var _this = this
      if (!_this.searchValue || _this.searchValue == '') {
        this.$message({
          message: '请输入关键词',
          type: 'warning'
        })
      } else {
        window.location.href = `/search/${_this.searchValue}`
      }
    },
    // 二级导航展开
    navShow(d){
      let _this = this
      // _this[d] = true
      _this.navDown = d
    },
    // 二级导航收起
    navClose(){
      let _this = this
      // _this[d] = false
      _this.navDown = 0
    },
    haddleNav(index, params){
      var _this = this

      _this.active = index
      _this.$router.push(params.url)
    },
    getPath(){
      var _this = this

      _this.active = _this.$route.meta.index
    },

    display(id){  
      var traget = document.getElementById(id);  
      if(traget.style.display=="block"){  
        traget.style.display="none";  
      }
    }  
  }
}
</script>
<style>
.containerTop {
  width: 100%;
  height: 606px;
  margin: 0 auto;
  position: relative;
  
}
.containerTop .wrap {
  position: relative;
}
.ziHead{
  margin: 0 auto;
  position: relative;
  z-index: 0;
  overflow: hidden;
  height: 100%;
  text-align: center;
}
.header1 {
  width: 1200px;
  height: 606px;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -600px;
}
.top {
  width: 1200px;
  height: 446px;
}
.logo {
  width: 549px;
  height: 179px;
  padding-top: 127px;
}
.fl {
  float: left;
}
.logo img {
  width: 549px;
  height: 179px;
  display: block;
}
.sousuo {
  width: 370px;
  height: 44px;
  padding-top: 132px;
  float: right;
}
.sousuo1 {
  width: 105px;
  height: 44px;
  background: url(../assets/image/gsqj_2.png) no-repeat;
  float: left;
}
.header1 .sousuo .el-input__inner {
  background-color: #FFF;
  background-image: none;
  border-radius: 1px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  color: #000000;
  display: inline-block;
  font-size: inherit;
  height: 34px;
  line-height: 34px;
  outline: 0;
  padding: 0px 8px;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 100%;
}
.header1 .sousuo .el-button {
  display: inline-block;
  white-space: nowrap;
  cursor: pointer;
  background: #0063ba;
  border: 1px solid #DCDFE6;
  color: #ffffff;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: .1s;
  font-weight: 500;
  font-size: 14px;
  border-radius: 1px;
  margin-left: 5px;
  padding: 9px 10px;
}
.footer {
  width: 100%;
  height: 90px;
  background-color: #016aad;
  padding-top: 27px;
}
.footer p {
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 34px;
}
.footer p span {
  margin-right: 10px;
}
.footer p a {
  color: #ffffff;
}
.gonggao {
  width: 100%;
  height: 133px;
  margin-top: -2px;
  background: url(../assets/image/gsqj_3.png) repeat-x;
}
.gonggao_1 {
  width: 1200px;
  height: 116px;
  margin: 0 auto;
}
.home_pre_l {
  width: 107px;
  height: 109px;
  margin-left: 17px;
  margin-top: 15px;
}

.inner{
  overflow: hidden;
  position: relative;
  height: 133px;
}
.homeTopInner{
  width: 1030px;
  height: 133px;
  margin-right: 20px;
  margin-left: 20px;
}

.homeTopInner h3 {
  font-size: 24px;
  color: #333333;
  font-weight: normal;
  line-height: 40px;
  padding-top: 18px;
}
.homeTopInner h3 a:hover{
  color: #004688;
}
.homeTopInner p a {
  color: #ec6941;
}
.homeTopInner p {
  font-size: 14px;
  color: #999999;
  line-height: 30px;
}

.wrap .nav_box {
  width: 100%;
  height: 38px;
  background: url(../assets/image/gsqj_2.jpg) no-repeat;
}
.nav_box {
  width: 1200px;
  height: 36px;
  margin: 0px auto;
  position: relative;
  padding: 1px 0px;
}
.nav_box li {
  position: relative;
  float: left;
  width: 133px;
  height: 36px;
  line-height: 36px;
  font-size: 18px;
  color: #FFFFFF;
  text-align: center;
  background: url(../assets/image/gsqj_1.jpg) no-repeat;
  background-position: right center;
}
.nav_box li a {
  color: #FFFFFF;
  display: block;
  width: 100%;
}
.nav_box .nav_grop:hover {
  height: 36px;
  color: #FFFFff;
  line-height: 36px;
  background: url(../assets/image/gsqj_3.jpg) no-repeat;
  background-position: center center;
}
.nav_down .nav_down_wrap {
  width: 131px;
  position: absolute;
  top: 36px;
  left: 0;
  border-top: 0;
  text-align: left;
  padding: 0;
  line-height: 36px;
  z-index: 9999;
  background: url(../assets/image/bycl_11.png) repeat;
}
.nav_down .nav_down_wrap p a {
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  display: block;
  height: 35px;
  width: 131px;
}
.nav_down .nav_down_wrap  p a:hover{
  background-color: rgb(1,89,145) !important;
}
.main{
  width: 100%;
  height: auto;
  margin: 20px 0 20px 0;
}
.fundong {
    width: 79px;
    height: 500px;
    position: fixed;
    top: 250px;
    right: 50px;
}
.fundong_weixin {
    position: relative;
}
.imgWei{
  background: url(../assets/image/zdjt_28.jpg) no-repeat;
}
.fundong div {
    width: 79px;
    height: 113px;
    margin-bottom: 2px;
}
.fundong_weixin .weixinImg {
    width: 113px;
    height: 113px;
    display: none;
    position: absolute;
    top: 0;
    left: -113px;
    z-index: 8888;
}
.fundong_weixin:hover .imgWei{
  background: url(../assets/image/zdjt_31.jpg) no-repeat; 
}
.fundong_weixin .weixinImg{
  display: block;
  z-index: 8888;
}
.email{
  background: url(../assets/image/zdjt_30.jpg) no-repeat;
}
.fundong_youxiang:hover .email{
  background: url(../assets/image/zdjt_33.jpg) no-repeat;
}
.cha {
    display: block;
    width: 12px;
    height: 12px;
    position: absolute;
    right: 0;
    top: -20px;
}
.cha img {
    display: block;
    width: 12px;
    height: 12px;
}
</style>